// import { Languages } from '@/components/shared/enums/Languages'
import PushNotificationsController from '@/controllers/PushNotificationsController'
// import V6RedirectionController from '@/controllers/V6RedirectionController'
import { EventBus } from '@/eventBus'
import AuthService from '@/services/AuthService'
import UserService from '@/services/UserService'
import {
  FloatingWindowType,
  getFloatingWindowIcon
} from '@/shared/infrastructure/enums/Layout/FloatingWindowType'
import Colors from '@/utils/Colors'
import link from '@/utils/links'
import LottieAnimation from 'lottie-web-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { KeybeIconType } from '../../../enums/icons/KeybeIconType'

// components
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'
import KBListMenu from '@/shared/infrastructure/ui/menus/KBListMenu.vue'
import KBMenu from '@/shared/infrastructure/ui/menus/KBMenu/KBMenu.vue'
import VideoCampaign from '@/shared/infrastructure/ui/players/VideoCampaign/VideoCampaign.vue'
// import StatusAvatar from '@/components/shared/components/StatusAvatar.vue'
import OnboardingUseCases from '@/modules/SignInOnboarding/application/OnboardingUseCases'
import OnboardingController from '@/modules/SignInOnboarding/infrastructure/controllers/Onboarding.controller'
import { VecindarioConfigUseCases } from '@/modules/bky/application/VecindarioConfigUseCases'
import { VecindarioConfig } from '@/modules/bky/domain/VecindarioConfig'
import VecindarioConfigController from '@/modules/bky/infrastructure/controllers/VecindarioConfig.controller'
import AdviserStatusController from '@/modules/conversations/infrastructure/controllers/AdviserStatus.controller'
import KeybeAppSelector from '@/shared/infrastructure/ui/KeybeAppSelector/KeybeAppSelector.vue'
import moment from 'moment'
import { User } from '@/components/models/User'
import { UserType, UserTypes } from '@/modules/Permissions/domain/UserTypes'
import AppsUseCases from '@/modules/Apps/application/AppsUseCases'
import AppsController from '@/modules/Apps/infrastructure/controllers/Apps.controller'
import FeesServices from '@/modules/configuration/application/services/FeesServices'
import { StatusActive } from '@/Enums/StatusActive'
import UserFloatingMenuContainer from '@/modules/UserFloatingMenu/UserFloatingMenuContainer/UserFloatingMenuContainer.vue'
import StatusAvatar from '@/components/shared/components/StatusAvatar.vue'
import { loadLanguageAsync } from '@/plugins/i18n/i18n'
import { KeybeUserExtradata } from '@/models/KeybeUserExtradata'
import KeybeLabel from '@/modules/DesignSystem/infrastructure/components/KeybeLabel/KeybeLabel.vue'
import AccountStatus from '../../AccountStatus.vue'
export default {
  name: 'KeybeSidebar',
  mounted () {
    this.getFeesUser()
    EventBus.$on(
      'startConfigOnboarding--wizard',
      this.startConfigOnboarding.bind(this)
    )
    EventBus.$on(
      'closeConfigOnboarding--wizard',
      this.stopConfigOnboarding.bind(this)
    )
    this.getOnboardingStep()
    this.getConfig()
    this.getFlowsActive()
    this.extradata = new KeybeUserExtradata(this.userExtradata)
  },
  data () {
    return {
      link,
      Colors,
      KeybeIconType,
      getFloatingWindowIcon,
      FloatingWindowType,
      campaignOpenedAt: null,
      menuOpen: false,
      showConfigOnboarding: false,
      rerender: 0,
      onboardingController: new OnboardingController(),
      vecindarioConfig: null,
      vecindarioConfigController: new VecindarioConfigController(),
      gettingVecindarioUrl: false,
      vecindarioScheduleUrl: '',
      appsController: new AppsController(),
      app: null,
      loading: false,
      intervalId: null,
      hasFlows1: false,
      isFeesAdmin: false,
      extradata: null
    }
  },
  components: {
    // StatusAvatar,
    KeybeIcon,
    KBMenu,
    KBListMenu,
    LottieAnimation,
    VideoCampaign,
    KeybeAppSelector,
    UserFloatingMenuContainer,
    StatusAvatar,
    KeybeLabel,
    AccountStatus
  },
  computed: {
    ...mapState('BikyStore', ['config']),
    ...mapState('BillingStore', ['appConfig', 'tier']),
    ...mapState('FloatingWindowsStore', ['minimizedWindows']),
    ...mapState('ConversationStore', ['conversationQuery']),
    ...mapState('LayoutStore', ['listBoxWidth']),
    ...mapState('UserStore', ['user', 'token', 'isUserReadonly']),
    ...mapState('AppStore', ['selectedApp', 'language']),
    ...mapState('CompanyStore', ['selectedCompany']),
    ...mapState('ConversationStore', ['wpProviders']),
    ...mapState('ConversationStore', ['sound']),
    ...mapGetters('AppStore', ['isCDPApp', 'isKeybeApp', 'isGWMApp']),
    ...mapGetters('UserStore', [
      'isLoggedIn',
      'getToken',
      'isAgent',
      'isSuperAdmin',
      'isAdmin',
      'isAdminOrAbove',
      'isTrainer',
      'isCoordinatorOrAbove',
      'isCoordinator',
      'getUser',
      'getUserType'
    ]),
    hasBiky () {
      if (this.tier) {
        const splitTier = this.tier?.split(' ') || []
        const tierNumber = splitTier.length > 1 ? parseInt(splitTier[1], 10) : NaN
        return tierNumber >= 4
      } else return false
    },
    isConversations (): boolean {
      return this.$route.path === link.conversations
    },
    validateGWMUser (): boolean {
      if (this.isGWMApp) {
        return !this.isAgent && !this.isCoordinator
      }

      return true
    },
    userRole (): UserType {
      if (this.isSuperAdmin) {
        return UserTypes.SUPER_ADMIN
      }

      return this.getUserType || UserTypes.AGENT
    },
    isNotAgentNorTrainer () {
      return !this.isAgent && !this.isTrainer
    },
    inactiveApp (): boolean {
      const status = this.selectedApp?.status
      return status !== 'active'
    },
    userEmail () {
      return this.user?.email
    },
    userFullName (): string {
      return `${this.user?.name || ''} ${this.user?.lastName ?? ''}`.trim()
    },
    selectedAppName () {
      return this.selectedApp?.name || ''
    },
    selectedAppDefaultCountryCode () {
      return this.selectedApp?.defaultCountryCode || ''
    },
    selectedAppID () {
      return this.selectedApp?.uuid
    },
    selectedCompanyID () {
      return this.selectedCompany?.uuid
    },
    firstUserHost () {
      if (Array.isArray(this.wpProviders) && this.wpProviders.length > 0) {
        const provider = this.wpProviders.find(p => p.userHost && p.userHost.trim() !== '')
        return provider?.userHost || '+'
      } else {
        return '+'
      }
    },
    isInConversations () {
      return this.$route.path === link.conversations
    },
    isInPeople () {
      return (
        this.$route.path === link.people ||
        this.$route.path === link.businesses ||
        this.$route.path.includes('/segment') ||
        this.$route.path.includes('/business')
      )
    },
    isInPipelines () {
      return this.$route.path === '/sales' || this.$route.path.includes('sales')
    },
    isInOutbound () {
      return this.$route.path.includes('/outbound') || this.$route.path.includes('outbound')
    },
    isCarKBSystem (): boolean {
      return this.selectedApp?.categories?.includes('car')
    },
    modulesItems () {
      const baseItems = [
        {
          text: this.$t('Smart Chat'),
          icon: KeybeIconType.CHAT,
          subtitle: this.$t('smartchatSubtitle'),
          showBeta: false,
          url: `${process.env.VUE_APP_V6_URL}/admin/conversations?tokenV6=${this.token}&appId=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            this.goTo(link.conversations)
          }
        },
        {
          text: this.$t('Calendar'),
          icon: KeybeIconType.CALENDAR,
          subtitle: this.$t('calendarSubtitle'),
          showBeta: false,
          url: `${process.env.VUE_APP_CALENDAR_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            window.open(`${process.env.VUE_APP_CALENDAR_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`, '_self')
          }
        },
        {
          text: this.$t('CDP'),
          icon: KeybeIconType.PEOPLE,
          subtitle: this.$t('cdpSubtitle'),
          showBeta: false,
          url: `${process.env.VUE_APP_CDP_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            window.open(`${process.env.VUE_APP_CDP_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`, '_self')
          }
        },
        {
          text: this.$t('Funnels'),
          icon: KeybeIconType.FUNNELS,
          subtitle: this.$t('funnelsSubtitle'),
          showBeta: false,
          url: `${process.env.VUE_APP_FUNNELS_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`,
          callback: () => {
            if (this.inactiveApp) return
            EventBus.$emit('closeKBMenu')
            const url: string = `${process.env.VUE_APP_FUNNELS_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`
            window.open(url, '_self')
          }
        },
        {
          text: this.$t('OutboundHeader'),
          icon: KeybeIconType.CAMPAINS,
          subtitle: this.$t('outboundSubtitle'),
          showBeta: false,
          url: `${process.env.VUE_APP_V6_URL}/admin/outbound?tokenV6=${this.token}&appId=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            if (this.isAgent) return
            if (this.inactiveApp) return
            this.goTo('/outbound')
          }
        },
        {
          text: `${this.$t('metrics')}`,
          icon: KeybeIconType.METRICS,
          subtitle: this.$t('metricsSubtitle'),
          showBeta: true,
          url: `${process.env.VUE_APP_METRICS_URL}?token=${this.getToken}&appUUID=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            if (this.isAgent) return
            this.goToMetrics2()
          }
        },
        {
          text: this.$t('catalog'),
          icon: KeybeIconType.SHOPPING_CART,
          subtitle: this.$t('catalogSubtitle'),
          url: `${process.env.VUE_APP_CATALOG_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`,
          callback: () => {
            EventBus.$emit('closeKBMenu')
            if (this.isAgent) return
            if (this.inactiveApp) return
            const url: string = `${process.env.VUE_APP_CATALOG_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`
            window.open(url, '_self')
          }
        }
      ]

      if (this.isKeybeApp) {
        if (this.isCoordinatorOrAbove) {
          baseItems.push({
            text: this.$t('partners'),
            icon: KeybeIconType.HAND_SHAKE_OUTLINE,
            subtitle: this.$t('partnersSubtitle'),
            url: '',
            callback: () => {
              EventBus.$emit('closeKBMenu')
              this.setMaximazedWindow(FloatingWindowType.PARTNERS)
            }
          })
        }
      }

      const flowsItemSecond: any = {
        text: 'Flows',
        animation: true,
        icon: KeybeIconType.MOMENTS,
        showBeta: true,
        subtitle: this.$t('flowsSubtitle'),
        callback: () => {
          EventBus.$emit('closeKBMenu')
          if (this.isAgent) return
          if (!this.isUserReadonly) this.goToKBFlowsV2()
        }
      }

      // const consumptionItem: any = {
      //   text: this.$t('tabConsumptions'),
      //   icon: KeybeIconType.CASH,
      //   subtitle: this.$t('consumptionSubtitle'),
      //   callback: () => {
      //     EventBus.$emit('closeKBMenu')
      //     if (this.isAgent) return
      //     if (this.isFeesAdmin) this.setMaximazedWindow(FloatingWindowType.BILLING)
      //     else {
      //       const token = this.token
      //       const app = this.selectedApp.uuid
      //       const url: string = `${process.env.VUE_APP_BILLING_APP}?token=${token}&app=${app}&section=general`
      //       window.open(url, '_self')
      //     }
      //   }
      // }

      // Validate if is admin or above to show flows
      if (this.isAdminOrAbove) {
        baseItems.push(flowsItemSecond)
        // baseItems.push(consumptionItem)
      }
      const bikyItem = {
        text: this.config?.name || 'Biky Montes',
        icon: KeybeIconType.MAGIC,
        showBeta: false,
        animation: true,
        subtitle: this.$t('bikySubtitle'),
        url: `${process.env.VUE_APP_BIKY_URL}?token=${this.token}&app=${this.selectedApp?.uuid}`,
        callback: () => {
          EventBus.$emit('closeKBMenu')
          if (this.isAgent) return
          this.openBiky()
        }
      }

      baseItems.push(bikyItem)
      const vecindarioItem: any = {
        text: this.$t('scheduling'),
        icon: KeybeIconType.SCHEDULE,
        width: 14,
        height: 14,
        callback: () => {
          if (!this.isUserReadonly) this.openSchedule()
        }
      }

      if (this.hasVecindarioConfig && this.isCoordinatorOrAbove) {
        baseItems.push(vecindarioItem)
      }

      return baseItems.sort((a, b) => a.text.localeCompare(b.text))
    },
    profileItems () {
      return [
        {
          text: 'advisorStatus'
        },
        {
          text: this.$t('changePhoto'),
          icon: KeybeIconType.EXTERNAL,
          height: 14,
          width: 14,
          callback: () => {
            this.openFileInput()
          }
        },
        {
          text: this.$t('logout'),
          icon: KeybeIconType.EXTERNAL,
          height: 14,
          width: 14,
          callback: () => this._logout()
        }
      ]
    },
    showSideMenuMinimizedIcon () {
      if (this.listBoxWidth !== 0) {
        return false
      }
      return true
    },
    hasVecindarioConfig (): boolean {
      return this.vecindarioConfig?.active
    }
  },
  methods: {
    ...mapActions('FloatingWindowsStore', ['setMaximazedWindow']),
    ...mapActions('ConversationStore', ['setConversationQuery', 'setSound']),
    ...mapActions('LayoutStore', ['setListBoxWidth']),
    ...mapActions('UserStore', ['setUserExtradata']),
    goToNewVersion () {
      if (this.isInConversations) {
        window.open(`${process.env.VUE_APP_SMARTCHAT_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`, '_self')
      } else if (this.isInOutbound) {
        window.open(`${process.env.VUE_APP_OUTBOUND_URL}?token=${this.token}&appUUID=${this.selectedApp?.uuid}`, '_self')
      }
    },
    openMyKeybe () {
      window.open(`${process.env.VUE_APP_CONFIGURE_URL}/?token=${this.token || ''}&app=${this.selectedApp?.uuid || ''}&section=MY_KEYBE`, '_self')
    },
    async changeLanguage (lang) {
      await loadLanguageAsync(lang)
      this.localLang = lang
      this.$store.commit('AppStore/SET_APP_LANGUAGE', lang)

      const data = {
        property: 'lang',
        value: lang
      }
      const response = await UserService.updateUserExtradata(data)
      if (response.status) {
        this.extradata.updateExtradata(data)
        const newExtradata = this.extradata.getExtradata()
        await this.setUserExtradata(newExtradata)
      }
    },
    openBiky () {
      const url: string = `${process.env.VUE_APP_BIKY_URL}?token=${this.token}&app=${this.selectedApp?.uuid}`
      window.open(url, '_self')
    },
    openConfig () {
      window.open(`${process.env.VUE_APP_CONFIGURE_URL}/?token=${this.token || ''}&app=${this.selectedApp?.uuid || ''}`, '_self')
    },
    async getFeesUser () {
      const feesData = await FeesServices.isCommissionAgent()
      if (feesData?.status) {
        const user = feesData.data
        this.isFeesAdmin = user?.superadmin || false
      }
    },
    async getFlowsActive (): Promise<void> {
      this.hasFlows1 = await AppsUseCases.appHasFlows1(this.appsController, {
        uuid: this.selectedAppID,
        token: this.token
      })
    },
    async getOnboardingStep (): Promise<void> {
      const step: number = await OnboardingUseCases.getOnboardingStep(
        this.onboardingController
      )
      this.showConfigOnboarding = step === 2
      this.rerender++
    },
    goTo (link: string): void {
      EventBus.$emit('closeDrawer--details')
      if (this.$route.path === link) return
      if (this.inactiveApp) return
      if (link === this.link.conversations) {
        if (this.conversationQuery) {
          link = `${link}?${this.conversationQuery}`
          window.open(`${process.env.VUE_APP_V6_URL}/admin${link}?tokenV6=${this.token}&appId=${this.selectedApp?.uuid}`, '_self')
          return
        }
        window.open(`${process.env.VUE_APP_V6_URL}/admin${link}?tokenV6=${this.token}&appId=${this.selectedApp?.uuid}`, '_self')
        return
      }

      const query = this.$route.query
      let conversationQuery = ''
      if (query?.room) {
        conversationQuery = `room=${query.room}`
      }
      if (query?.quickFilter) {
        conversationQuery = `${conversationQuery}&quickFilter=${query.quickFilter}`
      }
      this.setConversationQuery(conversationQuery)
      window.open(`${process.env.VUE_APP_V6_URL}/admin${link}?tokenV6=${this.token}&appId=${this.selectedApp?.uuid}`, '_self')
    },
    openMenu () {
      EventBus.$emit('openSideMenu')
    },
    openFileInput () {
      this.$refs.imageInput.click()
    },
    async onFilePicked (event) {
      const img = event.target.files[0]
      this.imgUrl = URL.createObjectURL(img)
      const response = await UserService.uploadImage(img)
      if (response.status) {
        const photo = response?.data?.data?.info?.location
        const patchResponse = await UserService.updateProfile({ photo })
        if (patchResponse.status) {
          this.$store.commit(
            'UserStore/SET_KEYBE_USER',
            patchResponse.data.data.user
          )
          EventBus.$emit('toast', 'success', this.$t('profilePicUpdated'))
        } else {
          EventBus.$emit('toast', 'error', this.$t('errorUpdatingProfilePic'))
        }
      } else {
        EventBus.$emit('toast', 'error', this.$t('errorUploadingPicture'))
      }
    },
    async _logout () {
      await PushNotificationsController.setOneSignalStatus({ active: false })
      // Set adviser status to false
      await AdviserStatusController.inactiveIfIsAdviser(this.isAgent)
      await AuthService.logout()
      this.setListBoxWidth(null)
      this.logout()
      window.open(`${process.env.VUE_APP_BASE_KEYBE_URL}/signin`, '_self')
    },
    getStyleForMinimizedIcon (window) {
      const styles = {
        [FloatingWindowType.MY_KEYBE]: 'height: 14px; width: 14px;',
        [FloatingWindowType.MOMENTS]: 'height: 14px; width: 14px;',
        [FloatingWindowType.CAMPAIGNS]: 'height: 14px; width: 14px;',
        [FloatingWindowType.EXTENSION]: 'height: 14px; width: 14px;',
        [FloatingWindowType.BILLING]: 'height: 10px; width: 14px;',
        [FloatingWindowType.BILLING_KB]: 'height: 10px; width: 14px;',
        [FloatingWindowType.METRICS]: 'height: 13px; width: 14px;',
        [FloatingWindowType.ONBOARDING]: 'height: 14px; width: 16px;',
        [FloatingWindowType.TASK_CENTER]: 'height: 14px; width: 16px;'
      }
      return styles[window] || ''
    },
    showListBox () {
      EventBus.$emit('toggleListBox', false)
    },
    goToKBFlows () {
      setTimeout(() => {
        const url = `${
          process.env.VUE_APP_MAKE_REDIRECTION_URL
        }?name=${encodeURIComponent(
          this.selectedAppName
        )}&email=${encodeURIComponent(this.userEmail)}&appUUID=${
          this.selectedAppID
        }&companyUUID=${this.selectedCompanyID}&userHost=${encodeURIComponent(
          this.firstUserHost
        )}&v6=${this.isCDPApp}`
        window.open(url, '_self')
        this.$emit('cancel')
      }, 500)
    },
    goToKBFlowsV2 () {
      setTimeout(() => {
        const url = `${process.env.VUE_APP_FLOWS_V2_URL}/brand?appUUID=${
          this.selectedAppID ?? ''
        }&name=${encodeURIComponent(this.selectedAppName)}&companyUUID=${
          this.selectedCompanyID
        }&userHost=${encodeURIComponent(
          this.firstUserHost
        )}&email=${encodeURIComponent(
          this.userEmail
        )}&userName=${encodeURIComponent(this.userFullName)}&userUUID=${
          this.user.uuid
        }&token=${this.token}&language=${this.language}&categories=${(
          this.selectedApp?.categories || []
        ).join(',')}&defaultCountryCode=${this.selectedAppDefaultCountryCode}&role=${this.userRole}`
        window.open(url, '_self')
        this.$emit('cancel')
      }, 500)
    },
    goToCampaigns () {
      this.hideVideoCampaign()
      this.setMaximazedWindow(FloatingWindowType.CAMPAIGNS)
    },
    goToMetrics () {
      const preUserParam: User = this.getUser

      const userParam = {
        customId: preUserParam.customId,
        email: preUserParam.email,
        isSuperAdmin: preUserParam.isSuperAdmin,
        lastName: preUserParam.lastName,
        name: preUserParam.name,
        photo: preUserParam.photo,
        role: this.getUserType || '',
        uuid: preUserParam.uuid || ''
      }
      const user = encodeURIComponent(JSON.stringify(userParam))
      const app = this.selectedApp?.uuid || ''
      const company = this.selectedCompany.uuid
      const url = `${process.env.VUE_APP_ANALYTICS_PROYECT}/?token=${this.getToken}&user=${user}&companyId=${company}&appId=${app}&appName=${this.selectedAppName}&lang=${this.language}`
      window.open(url, '_self')
    },
    goToMetrics2 () {
      const url: string = `${process.env.VUE_APP_METRICS_URL}?token=${this.getToken}&appUUID=${this.selectedApp?.uuid}`
      window.open(url, '_self')
    },
    hideVideoCampaign () {
      this.campaignOpenedAt = moment().format('YYYY-MM-DDTHH:mm:ss')
    },
    showVideoCampaign () {
      if (this.campaignOpenedAt) {
        const now = moment()
        const openedAt = moment(this.campaignOpenedAt)
        const duration = moment.duration(now.diff(openedAt))
        const minutes = duration.asMinutes()
        if (minutes < 1) return
        else {
          this.campaignOpenedAt = null
        }
      }
      setTimeout(() => {
        const component = this.$refs['campaign-video']
        if (component && !component.isOpen) {
          this.$refs['campaign-video'].open()
        }
      }, 100)
    },
    startConfigOnboarding (): void {
      this.showConfigOnboarding = true
    },
    stopConfigOnboarding (): void {
      this.showConfigOnboarding = false
    },
    async getConfig (): Promise<void> {
      const config: VecindarioConfig = await VecindarioConfigUseCases.getConfig(
        this.vecindarioConfigController,
        {
          appUUID: this.selectedApp?.uuid,
          token: this.token
        }
      )

      this.vecindarioConfig = config
      if (this.vecindarioConfig && this.vecindarioConfig?.active) {
        await this.getScheduleUrl()
      }
    },
    async getScheduleUrl (): Promise<void> {
      const url: string = await VecindarioConfigUseCases.getCalendarUrl(
        this.vecindarioConfigController,
        {
          token: this.token,
          data: {
            slug: this.vecindarioConfig?.vecindarioSlug,
            email: this.user?.email
          }
        }
      )

      this.vecindarioScheduleUrl = url
    },
    openSchedule (): void {
      window.open(this.vecindarioScheduleUrl, '_self')
    },
    changeTheme (): void {
      this.$store.commit('UserStore/SET_DARK_MODE', this.$vuetify.theme.dark ? StatusActive.INACTIVE : StatusActive.ACTIVE)
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    changeSound () {
      this.setSound(!this.sound)
    }
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    EventBus.$off(
      'startConfigOnboarding--wizard',
      this.startConfigOnboarding.bind(this)
    )
    EventBus.$off(
      'closeConfigOnboarding--wizard',
      this.stopConfigOnboarding.bind(this)
    )
    VecindarioConfigUseCases.abortAll(this.vecindarioConfigController)
  },
  watch: {
    selectedAppID () {
      this.getFlowsActive()
    },
    inactiveApp: {
      handler (val, oldVal) {
        if (val === false && oldVal === true) {
          console.log('IS ACTIV!E')
        }
      },
      immediate: true
    }
  }
}
